import type { AddonManagementView } from 'components/AddonManagement/AddonManagementViewSelector';
import type { AppState } from 'state/state.model';

import type { AddonManagementFormFilters } from './filters.model';

export function getAddonManagementFiltersState(appState: AppState): Readonly<AddonManagementFormFilters> {
  return appState.addonManagementForm.filter;
}

export function getView(appState: AppState): AddonManagementView {
  const filters = getAddonManagementFiltersState(appState);
  return filters.view;
}
